import React,{useState,useEffect, useContext} from 'react';
import {
  Button, TextField, Radio, RadioGroup,
  FormControlLabel, FormControl, FormLabel, Select, MenuItem,
  Typography, Grid, InputAdornment, Box, IconButton,Modal,Alert,Snackbar,FormHelperText
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker,TimePicker } from '@mui/x-date-pickers';
import DeleteIcon from '@mui/icons-material/Delete';
import {enGB} from 'date-fns/locale';
import AppContext from '../AppContext';
import { db } from '../firebase'; 
import { collection, getDocs,doc,getDoc} from 'firebase/firestore';
import OrderSummaryPrint from './OrderSummaryPrint';
import AddIcon from '@mui/icons-material/Add';
import { Avatar } from '@mui/material';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';

const Checkout = ({ cartItems, onBackToShopping, onCancelOrder,orderDetails,onUpdateOrderDetails,onMoveToReview }) => {
  const [orderImages,setOrderImages]=useState([]);
  const [imagePreviews,setImagePreviews]=useState([]);
  const [showOrderSummaryPrint, setShowOrderSummaryPrint] = useState(false);
  const [promotionCodes, setPromotionCodes] = useState([]);
  const [enteredCode, setEnteredCode] = useState('');
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  const [errors, setErrors] = useState({});
  const [splitPayments, setSplitPayments] = useState(
    orderDetails.payments?.length > 0 ? orderDetails.payments : [{ method: 'Cash', amount: 0 }]
  );
  const { shopId, t } = useContext(AppContext);
  const [cashiers, setCashiers] = useState([]);


  useEffect(() => {
    // Fetch active promotion codes from Firestore
    const fetchPromotionCodes = async () => {
      const querySnapshot = await getDocs(collection(db, 'promotionCodes'));
      const codes = querySnapshot.docs.map(doc => doc.data())
        .filter(code => {
          const now = new Date();
          return code.startDate.toDate() <= now && code.endDate.toDate() >= now;
        });
      setPromotionCodes(codes);
    };
    fetchPromotionCodes();
  }, []);

  useEffect(() => {
    const fetchCashiers = async () => {
      const shopRef = doc(db, 'shops', shopId);
      const shopSnap = await getDoc(shopRef);
      if (shopSnap.exists()) {
        const cashiers = shopSnap.data().cashiers || [];
        setCashiers(cashiers);
        console.log(shopId);
        console.log(cashiers);
      }
    };
    fetchCashiers();
  }, [shopId]);

  const calculateOrderDetails = (currentDetails, field, value) => {
    // Existing switch cases for numeric calculations
    if (field === 'deliveryFeeAmount' || field === 'discount') {
      const numericValue = parseFloat(value) || 0;
      
      switch (field) {
        case 'deliveryFeeAmount':
          const subtotalWithDelivery = currentDetails.subtotal + numericValue;
          const newTotal = subtotalWithDelivery + currentDetails.tax - currentDetails.discount;
          return {
            ...currentDetails,
            deliveryFeeAmount: numericValue,
            total: newTotal,
            remainingBalance: newTotal - (currentDetails.payments?.reduce((sum, p) => sum + p.amount, 0) || 0)
          };
          
        case 'discount':
          const totalAfterDiscount = currentDetails.subtotal + 
                                    currentDetails.deliveryFeeAmount + 
                                    currentDetails.tax - 
                                    numericValue;
          return {
            ...currentDetails,
            discount: numericValue,
            total: totalAfterDiscount,
            remainingBalance: totalAfterDiscount - (currentDetails.payments?.reduce((sum, p) => sum + p.amount, 0) || 0)
          };
      }
    }
    
    // Handle date and time synchronization
  if (field === 'fulfillmentDate') {
   
    const newDate = value instanceof Date ? value : new Date(value);
    let newFulfillmentTime = currentDetails.fulfillmentTime ? new Date(currentDetails.fulfillmentTime) : null;
    if (newFulfillmentTime) {
      // Set the date part of fulfillmentTime to the new date, keep the time part
      newFulfillmentTime.setFullYear(newDate.getFullYear());
      newFulfillmentTime.setMonth(newDate.getMonth());
      newFulfillmentTime.setDate(newDate.getDate());
    }
   
    return {
      ...currentDetails,
      fulfillmentDate: newDate,
      fulfillmentTime: newFulfillmentTime || currentDetails.fulfillmentTime
    };
   
  }

  if (field === 'fulfillmentTime') {
    const newTime = new Date(value);
    let newFulfillmentDate = currentDetails.fulfillmentDate ? new Date(currentDetails.fulfillmentDate) : null;
    if (newFulfillmentDate) {
      // Set the time part of fulfillmentDate to the new time, keep the date part
      newFulfillmentDate.setHours(newTime.getHours());
      newFulfillmentDate.setMinutes(newTime.getMinutes());
      newFulfillmentDate.setSeconds(newTime.getSeconds());
      newFulfillmentDate.setMilliseconds(newTime.getMilliseconds());
    }
    
    return {
      ...currentDetails,
      fulfillmentTime: newFulfillmentDate,
      fulfillmentDate: newFulfillmentDate || currentDetails.fulfillmentDate
    };
    
  }
    
    // Default case for other fields
    return {
        ...currentDetails,
        [field]: value
    };
};
  
  const handlePaymentChange = (index, field, value) => {
    const updatedPayments = [...splitPayments];
    if (field === 'amount') {
      updatedPayments[index][field] = parseFloat(value) || 0;
    } else {
      updatedPayments[index][field] = value;
    }
    setSplitPayments(updatedPayments);
    
    const totalPaid = updatedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    onUpdateOrderDetails({
      ...orderDetails,
      payments: updatedPayments,
      paymentAmount: totalPaid,
      remainingBalance: orderDetails.total - totalPaid
    });
  };

  const addPaymentMethod = () => {
    setSplitPayments([...splitPayments, { method: 'Cash', amount: 0 }]);
  };

  const removePaymentMethod = (index) => {
    const updatedPayments = splitPayments.filter((_, i) => i !== index);
    setSplitPayments(updatedPayments);
    
    const totalPaid = updatedPayments.reduce((sum, payment) => sum + payment.amount, 0);
    onUpdateOrderDetails({
      ...orderDetails,
      payments: updatedPayments,
      paymentAmount: totalPaid,
      remainingBalance: orderDetails.total - totalPaid
    });
  };
  const handleInputChange = (field, value) => {
  // onUpdateOrderDetails({[field]:value});
  const updatedDetails = calculateOrderDetails(orderDetails, field, value);
  onUpdateOrderDetails(updatedDetails);
  };

  const handleApplyPromotion = () => {
    const promo = promotionCodes.find(code => code.title === enteredCode);
    if (promo) {
      let discountValue = 0;
      if (promo.discountType === 'amount') {
        discountValue = promo.amountValue;
      } else if (promo.discountType === 'percentage') {
        discountValue = (promo.amountValue / 100) * (orderDetails.subtotal+orderDetails.tax+orderDetails.deliveryFeeAmount);
      }
      handleInputChange('discount',discountValue);
      setAlert({ open: true, message: t('Promotion applied successfully!'), severity: 'success' });
    } else {
      setAlert({ open: true, message: t('Invalid promotion code'), severity: 'error' });
    }
  };


  const handleCloseOrderSummary = () => {
     // Cleanup state
   
     setImagePreviews([]);
     setShowOrderSummaryPrint(false);
     onCancelOrder();
    
    
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const imagePreviewsArray = files.map((file) => URL.createObjectURL(file));
    
    // Combine existing and new images
    const updatedImages = [...orderImages, ...files];
    const updatedPreviews = [...imagePreviews, ...imagePreviewsArray];
  
    // Update local state
    setOrderImages(updatedImages);
    setImagePreviews(updatedPreviews);
  
    // Update order details with both files and preview URLs
    onUpdateOrderDetails({
      orderImages: updatedImages,
      orderImagePreviews: updatedPreviews
    });
  };
  
  const handleDeleteImage = (index) => {
    // Update local state
    const updatedImages = orderImages.filter((_, i) => i !== index);
    const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
    
    setOrderImages(updatedImages);
    setImagePreviews(updatedPreviews);
  
    // Update order details
    onUpdateOrderDetails({
      orderImages: updatedImages,
      orderImagePreviews: updatedPreviews
    });
  };


  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber} MMK`;
  };


  const handleProceedToReview = () => {
    const requiredFields = [
      'fulfillmentDate',
      'fulfillmentTime',
      'phoneNumber',
      'customerName',
      'cashierName'
    ];

    const missingFields = requiredFields.filter(field => !orderDetails[field]);
    const totalPaid = splitPayments.reduce((sum, payment) => sum + payment.amount, 0);
    
    if (missingFields.length > 0 || totalPaid < 0) {
      const errors = {};
      missingFields.forEach(field => {
        errors[field] = t('This field is required');
      });
      if (totalPaid < 0) {
        errors.payment = t('At least one payment is required');
      }
      setErrors(errors);
      return;
    }

    onMoveToReview();
  };


  return (
    <Box> 
      <Grid container spacing={3} mt={1}>
      <Grid item xs={6} sm={6} md={6}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <DatePicker
            label={t("Fulfillment Date")}
            value={orderDetails.fulfillmentDate}
            onChange={(date) => handleInputChange('fulfillmentDate', date)}
            slotProps={{ textField: { fullWidth: true, required: true, error: !!errors.fulfillmentDate, helperText: errors.fulfillmentDate } }}
            minDate={new Date()}
          />
        </LocalizationProvider>
      </Grid>
      {/**
      <Grid item xs={6} sm={6} md={6}>
        <FormControl component="fieldset">
          <FormLabel component="legend">{t("Select Period")}</FormLabel>
          <RadioGroup
            row
            value={orderDetails.period}
            onChange={(e) => handleInputChange('period', e.target.value)}
          >
            <FormControlLabel value="Morning" control={<Radio />} label={t("Morning (6:00 AM - 11:59 AM)")} />
            <FormControlLabel value="Evening" control={<Radio />} label={t("Evening (12:00 PM - 6:00 PM)")} />
          </RadioGroup>
        </FormControl>
      </Grid> */}

   
      <Grid item xs={6} sm={6} md={6}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopTimePicker
          label={t("Select Time")}
          value={orderDetails.fulfillmentTime}
          onChange={(date) => handleInputChange('fulfillmentTime', date)}
          ampm={true} // 12-hour format with AM/PM
          slotProps={{
            textField: {
              fullWidth: true,
              required: true,
              error: !!errors.fulfillmentTime,
              helperText: errors.fulfillmentTime,
            },
          }}
        />
      </LocalizationProvider>
      </Grid>
        
        <Grid item xs={12} sm={12} md={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">{t("Fulfillment Method")}</FormLabel>
            <RadioGroup
              row
              value={orderDetails.fulfillmentMethod}
              onChange={(e) => handleInputChange('fulfillmentMethod', e.target.value)}
            >
              <FormControlLabel value="Pickup" control={<Radio />} label={t("Pickup")} />
              <FormControlLabel value="Delivery" control={<Radio />} label={t("Delivery")} />
            </RadioGroup>
          </FormControl>
        </Grid>
        
        {orderDetails.fulfillmentMethod === 'Delivery' && (
          <>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t("Delivery Address")}
              value={orderDetails.deliveryAddress}
              onChange={(e) => handleInputChange('deliveryAddress', e.target.value)}
              required
              error={!!errors.deliveryAddress}
              helperText={errors.deliveryAddress}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <TextField
            fullWidth
            label={t("Delivery Charge")}
            type="number"
            value={orderDetails.deliveryFeeType === 'Collect' ? 0 : orderDetails.deliveryFeeAmount}
            onChange={(e) => handleInputChange('deliveryFeeAmount',e.target.value)}
            disabled={orderDetails.deliveryFeeType === 'Collect'}
            InputProps={{
              endAdornment: <InputAdornment position="end">{t("MMK")}</InputAdornment>,
            }}
          />
        </Grid>
          <Grid item xs={12} sm={12}>
          <FormControl fullWidth>
            <FormLabel>{t("Delivery Charge Method")}</FormLabel>
            <RadioGroup
              row
              value={orderDetails.deliveryFeeType}
              onChange={(e) => handleInputChange('deliveryFeeType', e.target.value)}
            >
              <FormControlLabel value="Advance" control={<Radio />} label={t("Advance")} />
              <FormControlLabel value="Collect" control={<Radio />} label={t("Collect")} />
            </RadioGroup>
          </FormControl>
        </Grid>
       
        </>
        )}
          <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("Customer Name")}
            value={orderDetails.customerName}
            onChange={(e) => handleInputChange('customerName', e.target.value)}
            required
            error={!!errors.customerName}
            helperText={errors.customerName}
          />
        </Grid>
          <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("Phone Number")}
            value={orderDetails.phoneNumber}
            onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
            required
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
          />
        </Grid>
      
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label={t("Order Notes")}
            value={orderDetails.orderNotes}
            onChange={(e) => handleInputChange('orderNotes', e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={handleImageUpload}
          />
          <label htmlFor="raised-button-file">
            <Button variant="contained" component="span" disableElevation>
              {t("Insert Images")}
            </Button>
          </label>
          {orderDetails.orderImagePreviews && orderDetails.orderImagePreviews.length > 0 && (
            <Box mt={2}>
              {orderDetails.orderImagePreviews.map((image, index) => (
                <Box key={index} mt={2} mr={2} sx={{ position: 'relative', display: 'inline-block' }}>
                  <Typography variant="body2">
                    {image.name}
                  </Typography>
                  <img 
                    src={image} 
                    alt=""
                    style={{ width: '200px', height: '200px', objectFit: 'contain' }}
                  />
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: -20,
                      right: -20,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      },
                      color:'red'
                    }}
                    onClick={() => handleDeleteImage(index)}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}
            </Box>
          )}
        </Grid>
        
        <Grid item xs={12}>
          <Typography variant="h6">{t("Payment Details")}</Typography>
          {splitPayments.map((payment, index) => (
            <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
              <Grid item xs={12} md={5}>
                <FormControl fullWidth>
                  <Select
                    value={payment.method}
                    onChange={(e) => handlePaymentChange(index, 'method', e.target.value)}
                  >
                    <MenuItem value="Cash">{t("Cash")}</MenuItem>
                    <MenuItem value="Kpay">{t("Kpay")}</MenuItem>
                    <MenuItem value="WavePay">{t("Wave Pay")}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={10} md={5}>
                <TextField
                  fullWidth
                  type="number"
                  value={payment.amount}
                  onChange={(e) => handlePaymentChange(index, 'amount', e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">{t("MMK")}</InputAdornment>,
                  }}
                  error={!!errors.payment}
                  helperText={errors.payment}
                />
              </Grid>
              {splitPayments.length > 1 && (
                <Grid item xs={2} md={2}>
                  <IconButton onClick={() => removePaymentMethod(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          ))}
          <Button
            startIcon={<AddIcon />}
            onClick={addPaymentMethod}
            sx={{ mt: 1 }}
          >
            {t("Add Payment Method")}
          </Button>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {t("Total Paid")}: {formatToMyanmarCurrency(splitPayments.reduce((sum, p) => sum + p.amount, 0))}
          </Typography>
          <Typography variant="body2">
            {t("Remaining Balance")}: {formatToMyanmarCurrency(orderDetails.remainingBalance || orderDetails.total)}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={t("Promotion Code")}
            value={orderDetails.enteredCode}
            onChange={(e) => handleInputChange('enteredCode', e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button variant="contained" color="primary" onClick={handleApplyPromotion} disableElevation>
                    {t("Add")}
                  </Button>
                </InputAdornment>
              ),
            }}
          />
          
        </Grid>   
        <Grid item xs={12}>
        <FormControl fullWidth>
        <FormLabel>{t("Cashier Name")}</FormLabel>
        <Box 
          sx={{ 
            display: 'flex',
            overflowX: 'auto',
            gap: 2,
            py: 2,
            '&::-webkit-scrollbar': {
              height: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgba(0,0,0,.2)',
              borderRadius: '4px',
            },
            border: errors.cashierName ? '1px solid red':'none',
            borderRadius: errors.cashierName? 2:0,
          }}
        >
      {cashiers.map((name) => (
        <Box
          key={name}
          onClick={() => handleInputChange('cashierName', name)}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: 100,
            cursor: 'pointer',
            p: 1,
            borderRadius: 2,
            backgroundColor: orderDetails.cashierName === name ? 'grey.100' : 'transparent',
            '&:hover': {
              backgroundColor: 'grey.100',
            },
          }}
        >
          <Avatar
            sx={{ 
              width: 40, 
              height: 40, 
              mb: 1,
              fontSize: '1.5rem',
              backgroundColor: orderDetails.cashierName === name ? 'primary.main' : 'grey.500',
            }}
            alt={name}
          >
            {name.charAt(0)}
          </Avatar>
          <Typography 
            variant="body2" 
            sx={{ 
              textAlign: 'center',
              fontWeight: orderDetails.cashierName === name ? 'bold' : 'normal'
            }}
          >
            {name}
          </Typography>
            </Box>
          ))}
          </Box>
          
        </FormControl>
      </Grid>
        <Grid item xs={12} mb={3}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleProceedToReview} 
              disableElevation
            >
              {t("Review Order")}
            </Button>
            <Button 
              variant="contained" 
              color="secondary" 
              onClick={onCancelOrder} 
              disableElevation
            >
              {t("Cancel Order")}
            </Button>
            <Button 
              variant="outlined" 
              onClick={onBackToShopping} 
              disableElevation
            >
              {t("Back")}
            </Button>
          </Box>
        </Grid>     
      </Grid>

      <Modal
        open={showOrderSummaryPrint}
        onClose={handleCloseOrderSummary}
        aria-labelledby="order-summary-modal"
        aria-describedby="order-summary-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 800,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}>
          <OrderSummaryPrint
            orderDetails={orderDetails}
            onClose={handleCloseOrderSummary}
          />
        </Box>
      </Modal>

      <Snackbar
          open={alert.open}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => setAlert({ ...alert, open: false })}
        >
          <Alert onClose={() => setAlert({ ...alert, open: false })} severity={alert.severity}>
            {alert.message}
          </Alert>
        </Snackbar>
      
    </Box>
  );
};

export default Checkout;
